export default __webpack_public_path__ + "static/media/7007ROUGE.3bccdd70.pdf";